import 'bootstrap/dist/css/bootstrap.min.css';
import React, { Component } from 'react';
import './App.css';
import './desktop.css';
import './mobile.css';
import logo from './SE_Logo.svg';
import devices from './SE_Mockup1.png';
import ecoCreds from './ecocreds.png';
import onCallModuleLogo from './SE OnCall.svg';
import bookingsModuleLogo from './SE Bookings.svg';
import itRequestsModuleLogo from './SE IT Requests.svg';
import alertModuleLogo from './SE Alert.svg';
import { createBrowserRouter, Route, Link, createRoutesFromElements, RouterProvider, Navigate, useLocation } from "react-router-dom";
import MainApp from './mainApp/MainApp.js'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

import Dashboard from './mainApp/dashboard/Dashboard.js';

import BulkEmailTool from './mainApp/tools/bulkEmail/BulkEmailTool.js';
import EmailSignatureTool from './mainApp/tools/emailSignature/EmailSignatureTool.js';
import EmailSignatureSettings from './mainApp/tools/emailSignature/EmailSignatureSettings.js';
import ToolAccessGuard from './mainApp/tools/ToolAccessGuard.js';
import { BULK_EMAIL_TOOL_GUID, EMAIL_SIGNATURE_TOOL_GUID } from './mainApp/tools/toolRegistry.js';
import ToolsHome from './mainApp/tools/ToolsHome.js';
import ToolStaffAccess from './mainApp/tools/ToolStaffAccess.js';
import SysManagerTools from './mainApp/tools/SysManagerTools.js';
import SysManagerHomeLayout, { SysManagerHomeIndex } from './mainApp/sysManager/SysManagerHome.js';
import SysManagerLearners from './mainApp/sysManager/SysManagerLearners.js';
import SysManagerNewLearner from './mainApp/sysManager/SysManagerNewLearner.js';
import SysManagerBookings from './mainApp/sysManager/SysManagerBookings.js';
import SysManagerBookingTimetables from './mainApp/sysManager/SysManagerBookingTimetables.js';
import SysManagerRotas from './mainApp/sysManager/SysManagerRotas.js';
import SysManagerRotasHome from './mainApp/sysManager/SysManagerRotasHome.js';
import SysManagerReprographics from './mainApp/sysManager/SysManagerReprographics.js';
import SysManagerStaff from './mainApp/sysManager/SysManagerStaff.js';
import SysManagerContacts from './mainApp/sysManager/SysManagerContacts.js';
import SysManagerPerformanceManagement from './mainApp/sysManager/SysManagerPerformanceManagement.js';
import SysManagerOnCall from './mainApp/sysManager/SysManagerOnCall.js';
import SysManagerGeneralSettings from './mainApp/sysManager/SysManagerGeneralSettings.js';
import SysManagerGroups from './mainApp/sysManager/SysManagerGroups.js';
import FormsHome from './mainApp/forms/FormsHome.js';
import FormViewer from './mainApp/forms/FormViewer.js';
import ActiveFormStepsPage from './mainApp/forms/ActiveFormStepsPage.js';
import FormResponsesPage from './mainApp/forms/FormResponsesPage.js';
import MyFormResponsesPage from './mainApp/forms/MyFormResponsesPage.js';
import SysManagerForms from './mainApp/forms/SysManagerForms.js';

import ItSupport from './mainApp/itSupport/ItSupport.js';
import ItSupportForm from './mainApp/itSupport/ItSupportForm.js';
import ItAdminRequests from './mainApp/itSupport/ItAdminRequests.js';
import ItUserRequests from './mainApp/itSupport/ItUserRequests.js';
import ItAdminSrv from './mainApp/itSupport/ItRequestAdminSingleView.js';
import ItUserSrv from './mainApp/itSupport/ItRequestUserSingleView.js';

import Maintenance, { MaintenanceLegacyRequestsRedirect } from './mainApp/maintenance/Maintenance.js';
import MaintenanceForm from './mainApp/maintenance/MaintenanceForm.js';
import MaintenanceRequests from './mainApp/maintenance/MaintenanceRequests.js';
import MaintenanceSrv from './mainApp/maintenance/MaintenanceSingleView.js';

import Oncall from './mainApp/oncall/Oncall.js';
import OncallHome from './mainApp/oncall/OncallHome.js';
import OncallPreviousRequests from './mainApp/oncall/OncallPreviousRequests.js';
import OncallReports from './mainApp/oncall/OncallReports.js';
import OnCallReportsIndividualPupil from './mainApp/oncall/OnCallReportsIndividualPupil.js';
import OnCallReportGroupSummary from './mainApp/oncall/OnCallReportGroupSummary.js';
import OnCallReportWholeSchool from './mainApp/oncall/OnCallReportWholeSchool.js';
import OnCallReportComparison from './mainApp/oncall/OnCallReportComparison.js';

import Reprographics from './mainApp/reprographics/Reprographics.js';
import ReproForm from './mainApp/reprographics/ReproForm.js';
import ReproRequests from './mainApp/reprographics/ReproRequests.js';
import ReproRequestAdminSingleView from './mainApp/reprographics/ReproRequestAdminSingleView.js';
import ReproUserRequests from './mainApp/reprographics/ReproUserRequests.js';
import ReproRequestUserSingleView from './mainApp/reprographics/ReproRequestUserSingleView.js';
import ExternalLinks from './mainApp/externalLinks/externalLinks.js';

import SeInvnt from './mainApp/seInvnt/SeInvnt.js';
import SeInvntDashboard from './mainApp/seInvnt/SeInvntDashboard.js';
import SeInvntDevice from './mainApp/seInvnt/SeInvntDevice.js';
import SeInvntReports from './mainApp/seInvnt/SeInvntReports.js';

import BookingsHome from './mainApp/bookings/bookingsHome.js';
import BookingstsHome from './mainApp/bookingsts/bookingstsHome.js';

import PerformanceManagement from './mainApp/performanceManagement/PerformanceManagement.js';
import PerformanceManagementDashboard from './mainApp/performanceManagement/PerformanceManagementDashboard.js';
import PerformanceManagementRecordView from './mainApp/performanceManagement/PerformanceManagementRecordView.js';

import Alert from './mainApp/alert/Alert.js';
import AlertHome from './mainApp/alert/AlertHome.js';
import AlertCreate from './mainApp/alert/AlertCreate.js';
import AlertSingleView from './mainApp/alert/AlertSingleView.js';
import AppSupport from './mainApp/appSupport/AppSupport.js';
import AppSupportHome from './mainApp/appSupport/AppSupportHome.js';
import AppSupportCreate from './mainApp/appSupport/AppSupportCreate.js';
import AppSupportLanding from './mainApp/appSupport/AppSupportLanding.js';
import AppSupportFaq from './mainApp/appSupport/AppSupportFaq.js';
import AppSupportAbout from './mainApp/appSupport/AppSupportAbout.js';
import Profile from './mainApp/profile/Profile.js';
import Docs from './mainApp/support/Support.js';
import { ForgotPasswordConfirm, ForgotPasswordRequest } from './auth/ForgotPassword.js';

// REACT ICONS
import { IoPeople } from "react-icons/io5";
import { MdNotificationsActive } from "react-icons/md";
import { BsClockHistory } from "react-icons/bs";

/**
 * Redirect a legacy route while retaining query parameters such as request ids.
 */
function LegacyRouteRedirect({ to }) {
  const location = useLocation();
  return <Navigate to={{ pathname: to, search: location.search }} replace />;
}

/**
 * PublicModulePage renders an unauthenticated landing page for a module route.
 * The module logo is shown as the primary centered header content.
 */
function PublicModulePage({ moduleName, moduleLogo }) {
  return (
    <div>
      <MainNav />
      <div className="mainSitePublicModulePage">
        <header className="mainSitePublicModuleHeader">
          <img
            className="mainSitePublicModuleLogo"
            src={moduleLogo}
            alt={`${moduleName} module logo`}
          />
        </header>
      </div>
      <MainFooter />
    </div>
  );
}

/**
 * MainFooter renders the shared footer for public, unauthenticated marketing pages.
 */
function MainFooter() {
  return (
    <footer className="mainSiteFooter">
      <div className="mainSiteFooterInner">
        <a className="mainSiteFooterLink mainSiteFooterEmail" href="mailto:contact@schoolengine.co.uk">
          contact@schoolengine.co.uk
        </a>
        <div className="mainSiteFooterRight">
          <p className="mainSiteFooterText">
            &copy; 2026 School Engine Ltd. Registered in England and Wales. Company No. 17465505.
          </p>
          <Link className="mainSiteFooterLink" to="/privacy-policy">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
}

/**
 * PrivacyPolicyPage renders the public privacy policy for the web, Android, and iOS apps.
 * The copy is intentionally static so it can be used as the stable app-store privacy URL.
 */
function PrivacyPolicyPage() {
  return (
    <div>
      <MainNav />
      <main className="privacyPolicyPage">
        <article className="privacyPolicyContent">
          <header className="privacyPolicyHeader">
            <p className="privacyPolicyUpdated">Last updated: 14 May 2026</p>
            <h1>School Engine Privacy Policy</h1>
            <p>
              School Engine provides web, Android, and iOS applications that help schools manage
              operational workflows including IT support, reprographics, room bookings, on-call
              requests, maintenance, inventory, staff workflows, and related school administration.
            </p>
            <p>
              This Privacy Policy explains what personal data we collect, how we use it, and the
              choices available to users of the School Engine web app and mobile apps.
            </p>
          </header>

          <section>
            <h2>1. Who We Are</h2>
            <p>
              School Engine provides the School Engine platform to schools and other educational
              organisations.
            </p>
            <p>
              For most school data processed through School Engine, the school or organisation using
              School Engine is the data controller. School Engine acts as a data processor, providing
              the platform and processing data only to deliver the service to that school.
            </p>
            <p>
              For limited data relating to account administration, support, security, billing, and
              service improvement, School Engine may act as a data controller.
            </p>
          </section>

          <section>
            <h2>2. Platforms Covered</h2>
            <p>This Privacy Policy applies to:</p>
            <ul>
              <li>The School Engine web application</li>
              <li>The School Engine Android app</li>
              <li>The School Engine iOS app</li>
              <li>Related backend services, APIs, notifications, and authentication systems</li>
            </ul>
          </section>

          <section>
            <h2>3. Data We Collect</h2>
            <p>The data collected depends on the modules enabled by your school and your permissions.</p>

            <h3>Account and Login Data</h3>
            <p>We may collect and process:</p>
            <ul>
              <li>Name or display name</li>
              <li>Email address</li>
              <li>School or organisation name</li>
              <li>School code or school identifier</li>
              <li>User ID or authentication ID</li>
              <li>Login and session information</li>
              <li>User permissions and access settings</li>
            </ul>
            <p>Authentication may be handled using secure identity services.</p>

            <h3>School Operational Data</h3>
            <p>Depending on the modules your school uses, School Engine may process data such as:</p>
            <ul>
              <li>IT support requests</li>
              <li>Reprographics requests</li>
              <li>Maintenance requests</li>
              <li>Room and resource bookings</li>
              <li>On-call or SLT call records</li>
              <li>Staff names, groups, roles, departments, or classes</li>
              <li>
                Learner names, groups, year groups, or class information where required by the
                enabled school workflows
              </li>
              <li>Notes, request descriptions, status updates, comments, timestamps, and audit history</li>
              <li>Notification preferences</li>
              <li>Dashboard links and school-specific configuration</li>
            </ul>
            <p>
              This data is provided by users, school administrators, or school systems connected to
              School Engine.
            </p>

            <h3>Web App Data</h3>
            <p>When using the web version, we may collect:</p>
            <ul>
              <li>Login and session tokens</li>
              <li>Browser and device information</li>
              <li>IP address and approximate access location from server logs</li>
              <li>App usage events needed for security, debugging, and service operation</li>
              <li>Permission data used to decide which modules and features you can access</li>
            </ul>
            <p>
              The web app may use browser storage, such as local storage or session storage, to keep
              users signed in and maintain app functionality.
            </p>

            <h3>Android and iOS App Data</h3>
            <p>The mobile apps may collect:</p>
            <ul>
              <li>Email address and login credentials submitted during authentication</li>
              <li>Authentication tokens and refresh tokens</li>
              <li>Device identifier or app-generated device UUID</li>
              <li>Push notification token</li>
              <li>App version and platform information</li>
              <li>Basic app interaction data required to operate the service</li>
              <li>Crash or performance data if crash reporting is enabled</li>
            </ul>
            <p>
              Mobile app data is used to authenticate users, maintain secure sessions, register
              devices for notifications, and provide school workflow features.
            </p>

            <h3>Push Notification Data</h3>
            <p>If push notifications are enabled, School Engine may process:</p>
            <ul>
              <li>Device push notification tokens</li>
              <li>User ID or school ID linked to the notification token</li>
              <li>Notification type or category</li>
              <li>Delivery-related metadata</li>
            </ul>
            <p>
              Push notifications may be used for updates such as new requests, request changes,
              completed requests, bookings, or other school workflow alerts.
            </p>
          </section>

          <section>
            <h2>4. Data We Do Not Intentionally Collect</h2>
            <p>School Engine does not intentionally collect:</p>
            <ul>
              <li>Payment card details through the web or mobile apps</li>
              <li>Precise GPS location</li>
              <li>Health data, unless entered by a school user into a workflow field</li>
              <li>Biometric data</li>
              <li>Advertising identifiers for marketing tracking</li>
              <li>
                Personal contacts, photos, microphone recordings, or camera data unless a specific
                feature is later added and clearly disclosed
              </li>
            </ul>
          </section>

          <section>
            <h2>5. How We Use Data</h2>
            <p>We use personal data to:</p>
            <ul>
              <li>Provide access to the School Engine platform</li>
              <li>Authenticate users securely</li>
              <li>Apply user permissions</li>
              <li>Display school-specific modules and data</li>
              <li>Create, manage, update, and report on school operational requests</li>
              <li>Send notifications related to enabled workflows</li>
              <li>Maintain audit trails and service records</li>
              <li>Support schools and investigate issues</li>
              <li>Protect the platform from misuse or unauthorised access</li>
              <li>Improve reliability, security, and performance</li>
              <li>Comply with legal, regulatory, or contractual obligations</li>
            </ul>
          </section>

          <section>
            <h2>6. Legal Basis for Processing</h2>
            <p>Where School Engine acts as a processor, the school determines the legal basis for processing.</p>
            <p>Where School Engine acts as a controller, we may rely on:</p>
            <ul>
              <li>Contract: to provide the School Engine service</li>
              <li>Legitimate interests: to operate, secure, support, and improve the platform</li>
              <li>Legal obligation: where we must comply with applicable law</li>
              <li>Consent: where required, such as optional communications or permissions</li>
            </ul>
          </section>

          <section>
            <h2>7. Sharing Data</h2>
            <p>We do not sell personal data.</p>
            <p>
              We may share or process data with trusted service providers who help operate School
              Engine, including:
            </p>
            <ul>
              <li>Cloud hosting providers, including Amazon Web Services</li>
              <li>Authentication and security providers</li>
              <li>Email delivery providers</li>
              <li>
                Push notification services, including Firebase Cloud Messaging and Apple Push
                Notification service
              </li>
              <li>Error monitoring or crash reporting providers, if enabled</li>
              <li>Professional advisers where necessary</li>
              <li>Regulators or authorities where legally required</li>
            </ul>
            <p>These providers are only used where necessary to deliver, secure, or support the service.</p>
          </section>

          <section>
            <h2>8. International Transfers</h2>
            <p>
              School Engine primarily uses cloud infrastructure and service providers that may process
              data in the UK, EEA, or other regions. Where data is transferred internationally, we use
              appropriate safeguards where required by law, such as contractual protections or provider
              data processing terms.
            </p>
          </section>

          <section>
            <h2>9. Data Security</h2>
            <p>We use technical and organisational measures designed to protect personal data, including:</p>
            <ul>
              <li>Encrypted network communication using HTTPS</li>
              <li>Secure authentication and session handling</li>
              <li>Role-based permissions</li>
              <li>Access controls</li>
              <li>Server-side logging and monitoring</li>
              <li>Restricted administrative access</li>
              <li>Cloud provider security controls</li>
              <li>Encrypted storage where supported by the platform or provider</li>
            </ul>
            <p>
              On mobile devices, authentication and push notification data may be stored using
              platform security features such as encrypted app storage.
            </p>
            <p>
              No system is completely secure, but we take reasonable steps to protect data from
              unauthorised access, loss, misuse, or alteration.
            </p>
          </section>

          <section>
            <h2>10. Data Retention</h2>
            <p>
              School Engine retains personal data for as long as needed to provide the service to the
              relevant school, comply with contractual obligations, maintain audit records, and meet
              legal requirements.
            </p>
            <p>
              Schools may determine their own retention requirements for operational records stored in
              School Engine. Where a school ends its use of School Engine, data may be deleted,
              exported, or retained for a limited period according to the agreement with that school.
            </p>
          </section>

          <section>
            <h2>11. User Rights</h2>
            <p>Depending on your location and applicable law, you may have rights to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion</li>
              <li>Restrict processing</li>
              <li>Object to processing</li>
              <li>Request data portability</li>
              <li>Withdraw consent where processing is based on consent</li>
            </ul>
            <p>
              If you are a school staff member, parent, learner, or other user whose data is managed
              by a school, you should normally contact the school first because the school is usually
              the data controller.
            </p>
            <p>
              You can also contact School Engine at privacy@schoolengine.co.uk, and we will either
              respond directly or help direct your request to the relevant school.
            </p>
          </section>

          <section>
            <h2>12. Children and Learner Data</h2>
            <p>
              School Engine may process learner data where a school uses the platform for workflows
              involving learners, classes, year groups, or school support activities.
            </p>
            <p>
              School Engine does not provide the platform directly to children for general consumer
              use. Learner data is processed on behalf of the school and under the school's
              instructions.
            </p>
          </section>

          <section>
            <h2>13. Cookies and Local Storage</h2>
            <p>The web app may use cookies, local storage, or session storage to:</p>
            <ul>
              <li>Keep users signed in</li>
              <li>Store authentication and session information</li>
              <li>Remember app state</li>
              <li>Support security and access controls</li>
              <li>Improve reliability and performance</li>
            </ul>
            <p>School Engine does not use these technologies for third-party advertising tracking.</p>
          </section>

          <section>
            <h2>14. Mobile App Store Data</h2>
            <p>
              When you download the Android or iOS app, Google Play or Apple App Store may collect
              data under their own privacy policies. School Engine does not control data collected
              directly by Google or Apple through their app stores.
            </p>
          </section>

          <section>
            <h2>15. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. The latest version will be made
              available on this page. If changes are significant, we may notify schools or users
              through the app, email, or other appropriate channels.
            </p>
          </section>

          <section>
            <h2>16. Contact Us</h2>
            <p>For privacy questions, data requests, or concerns, contact School Engine:</p>
            <p>
              Email: <a href="mailto:privacy@schoolengine.co.uk">privacy@schoolengine.co.uk</a>
            </p>
            <p>
              If you are unhappy with how your data is handled, you may also have the right to
              contact the UK Information Commissioner's Office at{' '}
              <a href="https://ico.org.uk" target="_blank" rel="noreferrer">https://ico.org.uk</a>.
            </p>
          </section>
        </article>
      </main>
      <MainFooter />
    </div>
  );
}

class MainNav extends Component {

  render() {
    return (
      <Navbar expand="lg" className="sticky-nav" style={{ position: "sticky" }}>
        <Container className="mainSiteNavContainer">
          <Navbar.Brand href="/">
            <img
              alt=""
              src={logo}
              height="50"
              className="d-inline-block align-top"
            />{' '}
          </Navbar.Brand>
          <div className="mainSiteNavTagline">Powering Smarter School Systems</div>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto">
              <Nav.Link href="/app"><div className='school_login_button'>School Login</div></Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    )
  }
};

class MainSite extends Component {

  render() {
    const moduleCards = [
      {
        id: 'oncall',
        name: 'OnCall',
        logo: onCallModuleLogo,
        route: '/oncall',
        description: 'Manage SLT callouts with fast submission, live tracking and reporting for safer school day operations.'
      },
      {
        id: 'bookings',
        name: 'Bookings',
        logo: bookingsModuleLogo,
        route: '/bookings',
        description: 'Book rooms and shared resources with clear ownership, live availability and fewer admin clashes.'
      },
      {
        id: 'it-requests',
        name: 'IT Requests',
        logo: itRequestsModuleLogo,
        route: '/it-requests',
        description: 'Log and manage IT support tickets from one place, with transparent updates for staff and technicians.'
      },
      {
        id: 'alert',
        name: 'Alert',
        logo: alertModuleLogo,
        route: '/alert',
        description: 'Send school-wide emergency and operational alerts quickly across devices for better communication and response.'
      }
    ];

    return (
      <div>
        <MainNav />

        <div className='MainSiteDiv'>

          <div className="mainSiteWhiteDiv1">
            <div className="mainSiteTextDiv">
              <h1 className="mainSiteHeading2">The Modular School Support System </h1>
              <img src={devices} className='devicesImage' alt='Devices'></img>
            </div>
          </div>

          <div className="mainSiteGreyDiv">
            <h1 className="mainSiteHeading3">Streamline Staff Workflows & Save Time with School Engine</h1>
            <div className="mainSitePdiv">
              <div className="mainSiteSinglePdiv"><IoPeople size={70} className="mainSitePIcon" /><p className="mainSitePtext">School Engine streamlines staff workflows by providing a dedicated platform for logging all support requests, from IT issues to SLT Calls.</p></div>
              <div className="mainSiteSinglePdiv"><BsClockHistory size={70} className="mainSitePIcon"/><p className="mainSitePtext">Eliminating the need for phone calls, running around or lost messages, ensuring every issue is tracked and addressed efficiently.</p></div>
              <div className="mainSiteSinglePdiv"><MdNotificationsActive size={70} className="mainSitePIcon"/><p className="mainSitePtext">Automated processes further streamline operations by sending notifications and updates, freeing up valuable staff time for more important tasks.</p></div>
            </div>
          </div>

          <div className="mainSiteSustainabilityDiv">
            <div className="mainSiteSustainabilityTextColumn">
              <h2 className="mainSiteSustainabilityHeading">Our Commitment to Sustainability</h2>
              <p className="mainSiteSustainabilityParagraph">
                At School Engine, environmental responsibility is one of our core values. Our platform runs on highly efficient cloud infrastructure powered by <strong>100 percent renewable energy</strong>, reducing the need for traditional on site servers and lowering energy waste.
              </p>
              <p className="mainSiteSustainabilityParagraph">
                Many School Engine tools also help schools cut <strong>paper, printing and photocopying</strong> by replacing paper processes with digital workflows, online forms and integrated communication.
              </p>
              <p className="mainSiteSustainabilityParagraph">
                By using School Engine, schools benefit from a powerful platform while also moving towards <strong>lower energy use, reduced paper consumption and more sustainable working practices</strong>. 🌍💚
              </p>
            </div>
            <div className="mainSiteSustainabilityImageColumn">
              <img src={ecoCreds} className="mainSiteSustainabilityImage" alt="School Engine sustainability credentials" />
            </div>
          </div>


          <div className="mainSiteWhiteDiv">
            <h1 className="mainSiteHeading3">Flexible School Management Tools You Can Add When You Need Them</h1>
            <div className="mainSiteColumnDiv">
              {moduleCards.map((moduleCard) => (
                <article className="mainSiteCol1Mod" key={moduleCard.id}>
                  <h2 className="mainSiteModuleHeading">
                    <img
                      className="mainSiteModuleLogo"
                      src={moduleCard.logo}
                      alt={`${moduleCard.name} module logo`}
                      loading="lazy"
                    />
                    <span className="mainSiteSrOnly">{moduleCard.name}</span>
                  </h2>
                  <p className="mainSiteModuleInfo">{moduleCard.description}</p>
                  <Link className="mainSiteLearnMoreButton" to={moduleCard.route}>
                    Learn More
                  </Link>
                </article>
              ))}
            </div>
          </div>
          <div className="mainSiteWhiteDiv">

          </div>
          <MainFooter />

        </div>
      </div>
    )
  }
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/">
      <Route index element={<MainSite />} /> {/* index prop is the same as path="/"*/}
      <Route path="alert" element={<PublicModulePage moduleName="Alert" moduleLogo={alertModuleLogo} />} />
      <Route path="bookings" element={<PublicModulePage moduleName="Bookings" moduleLogo={bookingsModuleLogo} />} />
      <Route path="it-requests" element={<PublicModulePage moduleName="IT Requests" moduleLogo={itRequestsModuleLogo} />} />
      <Route path="oncall" element={<PublicModulePage moduleName="OnCall" moduleLogo={onCallModuleLogo} />} />
      <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="forgot-password" element={<ForgotPasswordRequest />} />
      <Route path="forgot-password/confirm" element={<ForgotPasswordConfirm />} />

      <Route exact path="app" element={<MainApp />}>
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="support">
          <Route index element={<AppSupportLanding />} />
          <Route path="docs" element={<Docs />} />
          <Route path="requests" element={<AppSupport />}>
            <Route index element={<AppSupportHome />} />
            <Route path="new" element={<AppSupportCreate />} />
          </Route>
          <Route path="faq" element={<AppSupportFaq />} />
          <Route path="about" element={<AppSupportAbout />} />
        </Route>

        <Route path="ItSupport" element={<ItSupport />}>
          <Route index element={<ItSupportForm />} />
          <Route path="form" element={<ItSupportForm />} />
          <Route path="admin/requests" element={<ItAdminRequests />} />
          <Route path="user/requests" element={<ItUserRequests />} />
          <Route path="reports" element={<ItAdminSrv />} />
          <Route path="admin/requests/srv" element={<ItAdminSrv />} />
          <Route path="user/requests/srv" element={<ItUserSrv />} />
        </Route>

        <Route path="repro" element={<Reprographics />}>
          <Route index element={<ReproForm />} />
          <Route path="form" element={<ReproForm />} />
          <Route path="admin/requests" element={<ReproRequests />} />
          <Route path="admin/requests/srv" element={<ReproRequestAdminSingleView />} />
          <Route path="user/requests" element={<ReproUserRequests />} />
          <Route path="user/requests/srv" element={<ReproRequestUserSingleView />} />
          <Route path="requests" element={<LegacyRouteRedirect to="/app/repro/admin/requests" />} />
          <Route path="requests/srv" element={<LegacyRouteRedirect to="/app/repro/admin/requests/srv" />} />
        </Route>
        <Route path="ReproRequests" element={<LegacyRouteRedirect to="/app/repro/admin/requests" />} />

        <Route path="seInvnt" element={<SeInvnt />}>
          <Route index element={<SeInvntDashboard />} />
          <Route path="device" element={<SeInvntDevice />} />
          <Route path="reports" element={<SeInvntReports />} />
        </Route>

        <Route path="bookings/:group" element={<BookingsHome />} />
        <Route path="bookingsts" element={<BookingstsHome />} />

        <Route path="maintenance" element={<Maintenance />}>
          <Route index element={<MaintenanceForm />} />
          <Route path="form" element={<MaintenanceForm />} />
          <Route path="admin/requests" element={<MaintenanceRequests />} />
          <Route path="admin/requests/srv" element={<MaintenanceSrv />} />
          <Route path="user/requests" element={<MaintenanceRequests />} />
          <Route path="user/requests/srv" element={<MaintenanceSrv />} />
          <Route path="requests" element={<MaintenanceLegacyRequestsRedirect />} />
          <Route path="requests/srv" element={<MaintenanceLegacyRequestsRedirect singleView />} />
          <Route path="reports" element={<MaintenanceForm />} />
        </Route>

        <Route path="oncall" element={<Oncall />}>
          <Route index element={<OncallHome />} />
          <Route path="archive" element={<OncallPreviousRequests />} />
          <Route path="reports" element={<OncallReports />} />
          <Route path="reports/individual/:pupilId" element={<OnCallReportsIndividualPupil />} />
          <Route path="reports/comparison/wholeSchool" element={<OnCallReportComparison />} />
          <Route path="reports/comparison/:type/:groupName" element={<OnCallReportComparison />} />
          <Route path="reports/:type/:groupName" element={<OnCallReportGroupSummary />} />
          <Route path="reports/wholeSchool" element={<OnCallReportWholeSchool />} />
        </Route>

        <Route path="alert" element={<Alert />}>
          <Route index element={<AlertHome />} />
          <Route path="new" element={<AlertCreate />} />
          <Route path="single/:alertId" element={<AlertSingleView />} />
          <Route path=":alertId" element={<AlertSingleView />} />
        </Route>

        <Route path="appsupport" element={<Navigate to="/app/support" replace />} />

        <Route path="profile" element={<Profile />} />

        <Route path="performance-management" element={<PerformanceManagement />}>
          <Route index element={<PerformanceManagementDashboard />} />
          <Route path="dashboard" element={<PerformanceManagementDashboard />} />
          <Route path="record/:recordId" element={<PerformanceManagementRecordView />} />
        </Route>

        <Route path="tools" element={<ToolsHome />} />
        <Route path="tools/bulk-email" element={<ToolAccessGuard guid={BULK_EMAIL_TOOL_GUID}><BulkEmailTool /></ToolAccessGuard>} />
        <Route path="tools/email-signature" element={<ToolAccessGuard guid={EMAIL_SIGNATURE_TOOL_GUID}><EmailSignatureTool /></ToolAccessGuard>} />
        <Route path="forms" element={<FormsHome />} />
        <Route path="forms/manage" element={<SysManagerForms />} />
        <Route path="forms/responses/mine" element={<MyFormResponsesPage />} />
        <Route path="forms/steps" element={<ActiveFormStepsPage />} />
        <Route path="forms/:formId/responses" element={<FormResponsesPage />} />
        <Route path="forms/:formId" element={<FormViewer />} />

        <Route path="sysmanager" element={<SysManagerHomeLayout />}>
          <Route index element={<SysManagerHomeIndex />} />
          <Route path="tools" element={<SysManagerTools />} />
          <Route path="tools/access" element={<ToolStaffAccess key="module-access" moduleAccess />} />
          <Route path="tools/bulk-email/access" element={<ToolStaffAccess key="bulk-email-access" />} />
          <Route path="tools/email-signature" element={<EmailSignatureSettings />} />
          <Route path="tools/email-signature/access" element={<ToolStaffAccess key="email-signature-access" guid={EMAIL_SIGNATURE_TOOL_GUID} />} />
          <Route path="staff" element={<SysManagerStaff />} />
          <Route path="contacts" element={<SysManagerContacts />} />
          <Route path="groups" element={<SysManagerGroups />} />
          <Route path="general-settings" element={<SysManagerGeneralSettings />} />
          <Route path="learners" element={<SysManagerLearners />} />
          <Route path="learners/new" element={<SysManagerNewLearner />} />
          <Route path="bookings" element={<SysManagerBookings />} />
          <Route path="bookings/timetables" element={<SysManagerBookingTimetables />} />
          <Route path="reprographics" element={<SysManagerReprographics />} />
          <Route path="performance-management" element={<SysManagerPerformanceManagement />} />
          <Route path="oncall" element={<SysManagerOnCall />} />
          <Route path="forms" element={<SysManagerForms />} />
          <Route path="system" element={<MaintenanceForm />} />
          <Route path="rotas" element={<SysManagerRotasHome />} />
          <Route path="rotas/create" element={<SysManagerRotas />} />
          <Route path="rotas/:masterRotaId/edit" element={<SysManagerRotas />} />
        </Route>

      </Route>
    </Route>
  )
)

function App() {
  return (


    <div className="mainSite">
      <RouterProvider router={router} />
    </div>


  );
}

export default App;
